module.exports = __webpack_public_path__ + "static/img/findjobsbanner.403f745c.png";